// Test IDs for personal referral links, sharing, QR actions, and the public
// referral landing page.

export const REFERRAL = {
  hero: "referral-hero",
  link: "referral-link",
  copyLinkButton: "referral-copy-link-button",
  qrButton: "referral-qr-button",
  whatsappButton: "referral-whatsapp-button",
  moreShareButton: "referral-more-share-button",
  qrDialog: "referral-qr-dialog",
  qrDownloadButton: "referral-qr-download-button",
  sourceBadge: "referral-source-badge",
  landing: "referral-landing",
  landingForm: "referral-landing-form",
  firstNameInput: "referral-landing-first-name-input",
  lastNameInput: "referral-landing-last-name-input",
  phoneInput: "referral-landing-phone-input",
  cityInput: "referral-landing-city-input",
  messageInput: "referral-landing-message-input",
  consentCheckbox: "referral-landing-consent-checkbox",
  submitButton: "referral-landing-submit-button",
  thankYou: "referral-landing-thank-you",
  invalid: "referral-landing-invalid",
  expired: "referral-landing-expired",
  loadError: "referral-landing-load-error",
  selfReferralNotice: "referral-landing-self-referral-notice",
  dedupeNotice: "referral-landing-dedupe-notice",
  ownLinkNotice: "referral-landing-own-link-notice",
};
